module.exports = "pegasus_template/assets/background-patterns/white-carbon-fiber.png";